import React from "react"
import slugify from "slugify"
import { formatSource } from "../helpers/utils"

export default function Table({
  data,
  title,
  subTitle,
  figureNumber,
  tableNumber,
  classes,
  label,
  source,
  caption,
}) {
  const getKeys = () => {
    return Object.keys(data[0])
  }

  const getHeader = () => {
    var keys = getKeys()

    if (keys[0] === "0") {
      return (
        <tr>
          {keys.map((key, index) => {
            if (key === "0") {
              return <td key={index}></td>
            } else {
              return (
                <th scope="col" key={index}>
                  {key}
                </th>
              )
            }
          })}
        </tr>
      )
    } else {
      return (
        <thead>
          <tr>
            {keys.map((key, index) => {
              return (
                <th scope="col" key={index}>
                  {key}
                </th>
              )
            })}
          </tr>
        </thead>
      )
    }
  }

  const renderRow = row => {
    let rowObject = Object.entries(row)
    return rowObject.map((item, index) => {
      let header = item[0]
      let value = item[1]
      if (header === "0") {
        return (
          <th scope="row" key={index}>
            {value}
          </th>
        )
      } else {
        return <td key={index}>{value}</td>
      }
    })
  }

  const getRowsData = () => {
    let keys = Object.keys(data[0])
    let type = keys[0]

    if (type === "0") {
      return data.map((row, index) => <tr key={index}>{renderRow(row)}</tr>)
    } else {
      return (
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>{renderRow(row)}</tr>
          ))}
        </tbody>
      )
    }
  }

  const createId = () => {
    const id = title
      ? title
      : label
      ? label
      : `table__${Math.random().toString(10)}`
    return slugify(id).substring(0, 25)
  }

  return (
    <figure className={classes ? `table ${classes}` : "table"}>
      <div className="table__inner" role="region" aria-labelledby={createId()}>

        {figureNumber && (
          <div className="chart__figure-number">Figure {figureNumber}</div>
        )}
        {tableNumber && (
          <div className="chart__figure-number">Table {tableNumber}</div>
        )}
        {title && <h3 className="chart__title">{formatSource(title)}</h3>}
        {subTitle &&
          (title ? (
            <h4 className="chart__sub-title">{formatSource(subTitle)}</h4>
          ) : (
            <h3 className="chart__sub-title">{formatSource(subTitle)}</h3>
          ))}
        
        {caption && (
          <figcaption>
            {caption && <p className="chart__caption">{formatSource(caption)}</p>}
          </figcaption>
        )}
        
        <table id={`table__${slugify(title).substring(0, 25).toLowerCase()}`}>
          <caption id={createId()} className="util__screen-reader-only">
            {label}
          </caption>
          {getHeader()}
          {getRowsData()}
        </table>

        {source && (<p className="chart__source">{formatSource(source)}</p>)}
      </div>
    </figure>
  )
}
